<template>
  <b-card title="Novo Ajuste de Conta">
    <b-alert variant="warning" show>
      <div class="alert-body">
        <feather-icon icon="AlertTriangleIcon" class="mr-50" />
        <strong>Atenção:</strong> Esta operação atualizará imediatamente o saldo da conta selecionada e é irreversível na interface padrão.
      </div>
    </b-alert>

    <b-form @submit.prevent="save">
      <b-row>
        <!-- Tipo de Ajuste -->
        <b-col md="6">
          <b-form-group label="Tipo de Ajuste *">
            <b-form-radio-group
              v-model="form.tipoContabil"
              :options="tiposAjuste"
              name="tipo-ajuste"
              button-variant="outline-primary"
              buttons
              class="w-100"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Conta -->
        <b-col md="6">
          <b-form-group label="Conta *">
            <v-select
              v-model="form.conta"
              :options="contasOptions"
              label="nome"
              placeholder="Selecione a conta"
              :reduce="conta => conta"
              required
            >
              <template #option="{ nome, banco, agencia, conta }">
                <div class="d-flex flex-column">
                  <span><strong>{{ nome }}</strong></span>
                  <small v-if="banco" class="text-muted">{{ banco.nome }} - Ag: {{ agencia }} CC: {{ conta }}</small>
                </div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <!-- Valor -->
        <b-col md="4">
          <b-form-group label="Valor (R$) *">
            <money
              v-model="form.valor"
              v-bind="money"
              class="form-control text-right"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Data -->
        <b-col md="4">
          <b-form-group label="Data do Ajuste *">
             <flat-pickr
              v-model="form.data"
              class="form-control"
              :config="configDate"
              placeholder="Data da ocorrência"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Observações / Motivo -->
        <b-col md="12" class="mt-1">
          <b-form-group label="Motivo do Ajuste *">
            <b-form-textarea
              v-model="form.obs"
              rows="4"
              placeholder="Descreva detalhadamente o motivo que levou ao ajuste do saldo..."
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      
      <div class="d-flex justify-content-end mt-2">
        <b-button variant="outline-secondary" class="mr-1" @click="cancel">
          Voltar para Contas
        </b-button>
        <b-button type="submit" variant="primary">
          <feather-icon icon="SaveIcon" class="mr-50" />
          Registrar Ajuste
        </b-button>
      </div>
    </b-form>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BForm, BFormGroup, BFormTextarea, BButton, BAlert, BFormRadioGroup
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { Money } from 'v-money'
import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt'
import { mapState } from 'vuex'
import mixinsGlobal from '@/mixins'

export default {
  name: 'AjusteContaForm',
  components: {
    BRow, BCol, BCard, BForm, BFormGroup, BFormTextarea, BButton, BAlert, BFormRadioGroup,
    vSelect, Money, flatPickr
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      form: {
        id: '',
        obs: '',
        conta: null,
        data: new Date().toISOString().substring(0, 10), // Hoje
        valor: 0.0,
        tipoContabil: 'RECEITA'
      },
      tiposAjuste: [
        { text: 'Crédito (Adicionar)', value: 'RECEITA' },
        { text: 'Débito (Subtrair)', value: 'DESPESA' }
      ],
      configDate: {
        dateFormat: 'Y-m-d',
        locale: Portuguese
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    ...mapState('combosModule', {
      contasOptions: state => state.comboContas || []
    })
  },
  async mounted() {
    this.$store.dispatch('ajusteContaFinancialModule/reset')
    
    // Load combo contas if not loaded
    if (this.$store._actions['combosModule/loadComboContas']) {
      await this.$store.dispatch('combosModule/loadComboContas')
    }

    // Auto select conta from URL
    if(this.$route.query.contaId) {
       setTimeout(() => {
          const preSelected = this.contasOptions.find(c => String(c.id) === String(this.$route.query.contaId));
          if(preSelected) {
            this.form.conta = preSelected;
          }
       }, 500);
    }
  },
  methods: {
    async save() {
      // Validações Manuais
      if (!this.form.conta) {
        this.MensagemError('Validação', 'Selecione a conta para o ajuste.')
        return
      }
      if (this.form.valor <= 0) {
        this.MensagemError('Validação', 'O valor do ajuste deve ser maior que zero.')
        return
      }
      if (!this.form.obs || this.form.obs.trim() === '') {
        this.MensagemError('Validação', 'O motivo do ajuste é obrigatório.')
        return
      }

      const payload = { ...this.form }

      try {
        const response = await this.$store.dispatch('ajusteContaFinancialModule/insert', payload)
        
        if (response && response.data && response.data.id) {
          this.showMessageSuccess('Sucesso', 'Ajuste de Conta registrado e saldo atualizado com sucesso!')
          this.$router.push({ name: 'contas' })
        } else if (response.response && response.response.data && response.response.data.errors) {
          this.MensagemError('Erro', response.response.data.errors[0].message)
        } else {
          this.MensagemError('Erro', 'Falha ao registrar o ajuste de conta.')
        }
      } catch (error) {
        this.MensagemError('Erro', 'Ocorreu um erro na requisição.')
      }
    },
    cancel() {
      this.$router.push({ name: 'contas' })
    }
  }
}
</script>
